import _root_default from "./_root.js";
import _getNative_default from "./_getNative.js";

//#region ../../node_modules/lodash-es/_Set.js
var Set = _getNative_default(_root_default, "Set");
var _Set_default = Set;

//#endregion
export { _Set_default as default };
//# sourceMappingURL=_Set.js.map